export function initMyPages() {
  const myPage = document.querySelector('.my-page');
  if (!myPage) return;

  const buttons = myPage.querySelectorAll('button[role="tab"]');
  const forms = myPage.querySelectorAll('.accessibility-form');

  function handleClick(e) {
    const button = e.currentTarget;

    if (!button.classList.contains('active')) {
      const activeButton = button.parentElement.querySelector(
        'button.active[role="tab"]'
      );
      if (activeButton) activeButton.classList.remove('active');
      button.classList.add('active');

      const activeTab = myPage.querySelector(
        `[role="tabpanel"][data-tab="${activeButton.dataset.tab}"]`
      );
      if (activeTab) {
        activeTab.style.display = 'none';
        activeTab.classList.remove('active');
      }

      const newTab = myPage.querySelector(
        `[role="tabpanel"][data-tab="${button.dataset.tab}"]`
      );
      if (newTab) {
        newTab.style.display = 'block';
        newTab.classList.add('active');
      }
    }
  }

  function enhanceFormAccessibility(formContainer) {
    if (!formContainer) return;

    const controls = formContainer.querySelectorAll(
      'input:not([type=hidden]):not([type=submit]):not([type=button]):not([type=reset]), textarea, select'
    );

    controls.forEach(control => {
      const name = control.getAttribute('name');
      if (!name) return;

      const errorElement = document.querySelector(
        `.field-validation-error[data-valmsg-for="${name}"]`
      );
      if (!errorElement) return;

      const errorId = `${name}-error`;
      control.setAttribute('aria-describedby', errorId);
      errorElement.setAttribute('id', errorId);
    });
  }

  buttons.forEach(button => {
    button.addEventListener('click', handleClick);
  });

  forms.forEach(form => {
    enhanceFormAccessibility(form);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  const myPage = document.querySelector('.my-page');
  if (myPage) initMyPages();
});
